import { FC, useEffect, useState } from 'react';
import { Column, Table } from '@datum-group/isogd-openapi/lib';
import { Collapse, Spin } from 'antd';
import { ReferencedTableDisplay } from '@project/components/Module/RecordCard/ReferencedTables/ReferencedTableDisplay';
import { services } from '@project/API';
const { Panel } = Collapse;

export type ReferencedTableItem = Table & {
  referencedColumn: string;
  columnValue: string;
};

export const ReferencedTables: FC<{
  recordId: number | string;
  tableName: string;
}> = ({ recordId, tableName }) => {
  const [refTables, setRefTables] = useState<ReferencedTableItem[] | null>();
  const [refTablesLoading, setRefTablesLoading] = useState(false);

  const fetchRefTables = async (tableName: string) => {
    try {
      setRefTablesLoading(true);

      const referencedColumnsResponse = await services.table.apiColumnsList(
        1,
        0,
        { query: { references: tableName } },
      );

      const referencedColumns = referencedColumnsResponse.data.results;

      if (referencedColumns && !!referencedColumns.length) {
        const tablesNames = referencedColumns.map(
          (col: Column) => col.table_name,
        );
        const tablesListResponse = await services.table.apiTablesList(1, 0, {
          query: { table_name__in: tablesNames.join(',') },
        });

        const tablesList = tablesListResponse.data.results;

        if (tablesList) {
          const referencedTables = tablesList
            .map((table) => {
              // @ts-ignore
              const columnData = referencedColumns.find(
                (col: Column) => col.table_name === table.table_name,
              );

              if (!columnData) return {};

              return {
                ...table,
                referencedColumn: columnData.column_name,
                columnValue: recordId,
              };
            })
            .filter((v) => !!v);

          setRefTables(referencedTables as ReferencedTableItem[]);
        }
      }
    } catch (e) {
      console.error(e);
      setRefTables(null);
    }

    setRefTablesLoading(false);
  };

  useEffect(() => {
    fetchRefTables(tableName);
  }, [tableName, recordId]);

  return (
    <div className={'ref-table-container'}>
      {refTablesLoading ? (
        <div className={'ref-table-loading'}>
          <Spin />
        </div>
      ) : refTables?.length ? (
        refTables.map((table) => (
          <Collapse key={table.table_name}>
            <Panel header={table.description} key="1">
              <ReferencedTableDisplay table={table} />
            </Panel>
          </Collapse>
        ))
      ) : (
        <div>Связанные таблицы отсутствуют</div>
      )}
    </div>
  );
};
